import React, { useEffect, useState } from "react";
import {
  Box, Grid, Paper, TextField, InputAdornment, Chip,
  Stack, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Autocomplete,
  Typography,
  capitalize,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer
} from "@mui/material";
import {
  Search as SearchIcon,
  Home as HomeIcon,
  PointOfSale as PosIcon,
  ReceiptLong as ReceiptLongIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";

import ProductCard from "./productcard";
import InvoicePanel from "./invoicepanel";
import { fetchMonedas, fetchProductosFinancieros, fetchClientes } from "../../../../utils/generalsFetch";
import { formatIdentification, formatNumberWithCommas } from "../../../../utils/generalFunctions";
import Selector from "../../../../components/Selector";
import MetodoDePagoDialog from "../components/metododepagodialog";
import { StyledCellHeader } from "../../../../components/StyledCellHeader";
import { impresionrecibopagoinicial } from "../../prestamos/pagos/imprimirpagos";


const MOCK_PRODUCTS = [
  { id: "p1", name: "juwuw", price: 120, stock: 5, kind: "product", favorite: true },
  { id: "p2", name: "kdkd", price: 5, stock: 5, kind: "product" },
  { id: "s1", name: "Cambio de aceite", price: 850, stock: null, kind: "service" },
];

const DEFAULT_CLIENT = { id: "walkin", name: "Consumidor final" };


export default function PagoInicialScreen(props) {
  const [monto, setMonto] = React.useState("");
  const [moneda, setMoneda] = React.useState("RD$");
  const [productoSelected, setProductoSelected] = React.useState(null);
  const [camposInventario, setCamposInventario] = React.useState([]);
  const [financialProductSelected, setFinancialProductSelected] = React.useState(null);
  const [productosFinancieros, setProductosFinancieros] = React.useState([]);
  const [clientes, setClientes] = React.useState([]);
  const [clienteSelected, setClienteSelected] = React.useState(null);
  const [clienteInputValue, setClienteInputValue] = React.useState("");   
  const [nombreCliente, setNombreCliente] = React.useState("");
  const [productos, setProductos] = React.useState([]);
  const [descripcion, setDescripcion] = React.useState("");
  const [openMetodoDePago, setOpenMetodoDePago] = React.useState(false);
  const [inicialPagosHistorial, setInicialPagosHistorial] = React.useState([]);
  

  useEffect(() => {
    fetchMonedas({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      const monedaEncontrada = data.find((moneda) => moneda.value == "1");
      setMoneda(monedaEncontrada || { label: "RD", value: "1" });
    });
    fetchProductosFinancieros({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProductosFinancieros(data);
    });
    fetchClientes({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setClientes(data);
    });
    fetchInicialPagosHistorial();
  }, []);

  const handleClienteChange = (val) => {
    if(val){
      setNombreCliente(JSON.parse(val.campos)?.["1"]);
      setClienteInputValue(val.identificacion);
    }
    else{
      setNombreCliente("");
      setClienteInputValue("");
    }
    setClienteSelected(val);
    
  };

  const handleClienteInputChange = (event, newInputValue,reason) => {
    if (reason === 'input') {
      const formattedValue = formatIdentification(newInputValue);
      setClienteInputValue(formattedValue); // Esto mantiene formateado el input
      handleClienteSearch(formattedValue);
    } else if (reason === 'clear') {
      setClienteInputValue('');
      handleClienteSearch('');
    }
  }

  const handleClienteSearch = (val) => {
    var cliente = clientes.find(cliente => cliente.identificacion === val);
    if(cliente) {
      setClienteSelected(cliente);
      setNombreCliente(JSON.parse(cliente.campos)?.["1"]);
    } else {
      setClienteSelected(null);
      setNombreCliente("");
      setClienteInputValue("");
    }
  }

  const fetchInicialPagosHistorial = async () => {
    var fecha_desde = new Date().toISOString().split('T')[0];
    var fecha_hasta = new Date().toISOString().split('T')[0];
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/iniciales/pagos?idcompany=${localStorage.getItem('idcompany')}&fecha_desde=${fecha_desde}&fecha_hasta=${fecha_hasta}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id')
      }
    });
    const data = await response.json();
    setInicialPagosHistorial(data);
  }

  const handleConfirm = async(paymentData) => {
    if (!monto || parseFloat(monto) <= 0) return; // Validación simple

    let url = `${process.env.REACT_APP_SERVER_URL}/api/iniciales`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          monto:monto,
          identificacion:clienteInputValue,
          nombre:nombreCliente,
          id_producto:productoSelected["id"],
          descripcion:descripcion,
          id_sucursal:localStorage.getItem('id_sucursal'),
          created_by:localStorage.getItem('id'),
          idcompany:localStorage.getItem('idcompany'),
          metodo_pago:paymentData.payments.map(payment => ({
          method: payment.method,
          amount: payment.amount,
          reference: payment.reference
        }))})
      });
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        return;
      }
      var data = await response.json();
      handleClose();
      impresionrecibopagoinicial(nombreCliente,localStorage.getItem('nombre_compania'),"Pago de Inicial",new Date().toLocaleDateString(),monto,productoSelected["id"],[{concepto:"Inicial",total:monto}]);

    }
    catch (error) {
      console.log(error)
      throw error;
    }

  };

  const handleClose = () => {
    setMonto("");
    setDescripcion("");
    setProductoSelected(null);
    setFinancialProductSelected(null);
    setCamposInventario([]);
    setNombreCliente("");
    setClienteInputValue("");
    setProductos([]);
    
  };

  const onProductoFinancieroChange = async(e) => {
    var producto = productosFinancieros.find(producto => producto.idprodfinanciero === e.target.value);
    setCamposInventario(JSON.parse(producto.fields));
    setFinancialProductSelected(producto.idprodfinanciero);





    let url = `${process.env.REACT_APP_SERVER_URL}/api/productos/${localStorage.getItem('idcompany')}/${producto.id}?estado=disponible`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
      });
  
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        return;
      }

      var data = await response.json();
      setProductos(data.productos.filter(p => !data.iniciales.some(i => i.id_producto === p.id)));
      
    } catch (error) {
      console.log(error)
      throw error;
    }
  }

  return (
    <Grid container spacing={2}>
      
      <Grid item size={6}>
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, bgcolor: "white", minHeight: 450}}>
          <Typography fontWeight={600} variant="h6" textAlign={"left"} padding={2}>
            Historial de Pagos de Iniciales
          </Typography>

          {(inicialPagosHistorial && inicialPagosHistorial.length > 0) ? (
            
              <TableContainer component={Paper} sx={{mt: 2}}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <StyledCellHeader>Fecha</StyledCellHeader>
                      <StyledCellHeader>Monto</StyledCellHeader>
                      <StyledCellHeader>Cliente</StyledCellHeader>
                      <StyledCellHeader>Descripción</StyledCellHeader>
                      <StyledCellHeader>Método de Pago</StyledCellHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {inicialPagosHistorial.map((pago, idx) => (
                      <TableRow key={pago.id || idx}>
                        <TableCell>
                          {pago.created_at ? new Date(pago.created_at).toLocaleString() : "-"}
                        </TableCell>
                        <TableCell>
                          {pago.monto ? pago.monto.toLocaleString("es-DO", { style: "currency", currency: pago.moneda || "DOP" }) : "-"}
                        </TableCell>
                        <TableCell>
                          {pago.cliente
                            ? (JSON.parse(pago.cliente).nombre || JSON.parse(pago.cliente).identificacion || "-")
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {pago.descripcion || "-"}
                        </TableCell>
                        <TableCell>
                          {JSON.parse(pago.metodo_pago).map((metodo, idx) => (
                            <Chip key={idx} label={metodo.method} size="small" sx={{mr: 1}}/>
                          ))}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              
              
            ) : (
                <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="100%"
                minHeight={300}
                sx={{
                  border: '1px dashed #bdbdbd',
                  borderRadius: 2,
                  bgcolor: '#fafafa',
                  p: 4,
                  mt: 4
                }}>
                <Typography variant="h5" color="text.secondary" gutterBottom>
                  No hay pagos de iniciales registrados el dia de hoy.
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Cualquier pago de inicial registrado el dia de hoy se mostrara aqui.
                </Typography>
              </Box>


            )}
          </Paper>
        </Grid>
        
      <Grid item size={6} sx={{ display: "flex", justifyContent: "center" }}>
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, bgcolor: "white", width: "100%",}}>
          <Grid container spacing={2} mb={2} padding={2}>
            <Grid item size={8}>
              <Typography variant="h5" fontWeight={700} textAlign={"left"}>
                Cobrar Inicial
              </Typography>
            </Grid>
            <Grid item size={4}>
              <Chip
              size="small"
              icon={<PosIcon />}
              color={props.shiftOpen ? "success" : "default"}
              label={`Caja: ${props.shiftOpen ? "Disponible" : "Cerrada"}`}
              variant={props.shiftOpen ? "filled" : "outlined"}
            />

            </Grid>

            <Grid item size={12}>
              <Selector
                sx={{ width: 400, backgroundColor: "white"}}
                value={financialProductSelected}
                onChange={(e) => onProductoFinancieroChange(e)}
                options={productosFinancieros.map((producto) => ({
                  label: JSON.parse(producto.generales).nombre,
                  value: producto.idprodfinanciero,
                }))}
                placeholder="Tipo de producto"
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <Typography fontWeight={600} variant="h6">
                Datos del cliente
              </Typography>
            </Grid>
            <Grid item size={12}>
              <Autocomplete
                options={clientes}
                getOptionLabel={(option) => option.identificacion || ""}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Clientes" fullWidth />
                )}
                onChange={(e, val) => handleClienteChange(val)}
                onInputChange={(e, newInputValue, reason) => {
                  handleClienteInputChange(e, newInputValue, reason);
                }}
                inputValue={formatIdentification(clienteInputValue)}
                value={clienteSelected}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                placeholder="Nombre del cliente"
                value={nombreCliente}
                onChange={(e) => setNombreCliente(e.target.value)}
                disabled={!!clienteSelected}
              />
            </Grid>

            {(financialProductSelected && clienteSelected) ||
            (financialProductSelected && nombreCliente !== "") ? (
              <Grid container spacing={2} mb={2} mt={2}>
                <Grid item size={12}>
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    textAlign={"left"}
                  >
                    {capitalize(
                      camposInventario[0].alias + " para financiamiento"
                    )}
                  </Typography>
                </Grid>
                <Grid item size={12}>
                  <Autocomplete
                    options={productos}
                    getOptionLabel={(option) => option.id}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Productos" fullWidth />
                    )}
                    onChange={(e, val) => {
                      setProductoSelected(val);
                    }}
                    fullWidth
                  />
                </Grid>
                {productoSelected &&
                  camposInventario.map((campo, index) => {
                    var value = JSON.parse(productoSelected["campos"])[campo.id];
                    return (
                      <Grid item size={4} key={campo.id}>
                        <Typography
                          fontWeight={600}
                          textAlign={"left"}
                          mx={1}
                        >
                          {campo.id == "id"
                            ? capitalize(campo.alias)
                            : capitalize(campo.name)}
                        </Typography>
                        <TextField
                          slotProps={{
                            input: {
                              startAdornment:
                                campo.type === "monto" ? (
                                  <InputAdornment position="start">
                                    {moneda?.label || "RD"}$
                                  </InputAdornment>
                                ) : null,
                            },
                          }}
                          fullWidth
                          value={
                            campo.type == "monto"
                              ? formatNumberWithCommas(value?.toString())
                              : value
                          }
                          disabled={true}
                        />
                      </Grid>
                    );
                  })}
              </Grid>
            ) : null}
            {(financialProductSelected && productoSelected) && (
              <>
                <Grid item size={12}>
                  <Typography variant="body2" mt={2} textAlign={"left"}>
                    Ingrese el monto del inicial que desea cobrar:
                  </Typography>
                </Grid>
                <Grid item size={12}>
                  <TextField
                    fullWidth
                    placeholder="Monto del inicial"
                    value={formatNumberWithCommas(monto)}
                    onChange={(e) => {
                      setMonto(e.target.value.replace(/[^0-9.]/g, ""));
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">RD$</InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item size={12}>
                  <TextField
                    fullWidth
                    placeholder="Descripción"
                    value={descripcion}
                    onChange={(e) => {
                      setDescripcion(e.target.value);
                    }}
                  />
                </Grid>
              </>
            )}
            <Grid item size={12} mt={2} display="flex" justifyContent="flex-end">
              <Button onClick={() => {window.location.reload()}} color="inherit" sx={{ mr: 2 }}>
                Cancelar
              </Button>
              <Button
                sx={{ fontWeight: "bold" }}
                onClick={() => setOpenMetodoDePago(true)}
                color="primarybutton"
                variant="contained"
                disabled={(!monto || parseFloat(monto) <= 0)||(!props.shiftOpen)}
              >
                Confirmar
              </Button>
            </Grid>
          </Grid>
          <MetodoDePagoDialog
            open={openMetodoDePago}
            onClose={() => setOpenMetodoDePago(false)}
            onConfirm={handleConfirm}
            amount={parseFloat(monto.replace(/,/g, "") || 0)}
            title="Pago de Inicial"
            description="Seleccione el método de pago para el inicial"
            showAmount={true}
            defaultMethod="efectivo"
          />

        </Paper>
      </Grid>
    </Grid>

  );
}
